import ScratchPad from './ScratchPad';

export default ScratchPad;
